import script from "./Sermon.vue?vue&type=script&setup=true&lang=js"
export * from "./Sermon.vue?vue&type=script&setup=true&lang=js"

import "./Sermon.vue?vue&type=style&index=0&id=7853328f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7853328f"]])

export default __exports__